import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {selectEnv} from 'reducers/env';
import {getInvite, selectInvite} from 'api/invite';

import {goAfterLogin} from 'utils/AuthService';

const namespace = 'flows/interest/invite';

// Actions
const LOAD_INVEST_INVITE = defineAction('LOAD_INVEST_INVITE', namespace);
const SUBMIT_INVEST_INVITE = defineAction('SUBMIT_INVEST_INVITE', namespace);

export const loadInvestInvite = createAction(LOAD_INVEST_INVITE.ACTION);
export const submitInvestInvite = createAction(SUBMIT_INVEST_INVITE.ACTION);

// Invest Invite Saga
export function* investInviteSaga({payload}) {
  const {id} = payload;

  // Get the invite when the page loads
  // TODO: skip this page if already logged in
  yield put(getInvite({id}));

  // Wait for the user to click the login link
  yield take(SUBMIT_INVEST_INVITE.ACTION);

  // Take them to the login page, with a post-login redirect
  const env = yield select(selectEnv);
  const {allocation} = (yield select(selectInvite, id)).data;
  if (env.web) {
    const after = btoa('/invest/confirm');
    yield call(goAfterLogin, `/invest${allocation.self}/agreement/after/${after}/confirm/no`, true);
    yield call(browserHistory.push, '/login');
  }
}

export function* sagas() {
  yield takeLatest(LOAD_INVEST_INVITE.ACTION, investInviteSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/invest/invite/index.js